export default {"src":"/_next/static/media/image4.091bddc3.svg","height":118,"width":310,"blurWidth":0,"blurHeight":0};